import * as ko from "knockout";
import {IDialogOptionsComponent} from "../../dialog";
import {createErrorMessage, getPermissionDefinition, isPartOf} from "../../../util/misc";
import {Permission} from "../../../constants";
import {IMessageData} from "../../../index";
import {PLEASE_WAIT_MESSAGE, RESTORING_MESSAGE} from "../../../constants/Language";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import PromiseRequest from "../../../req/PromiseRequest";
import {ButtonManager} from "../../../util/ButtonManager";
import {getCancelButton, getContinueButton} from "../../../constants/RouteDefinitions";
import {nsRoute} from "../../../util/route";
import ButtonOrder = nsRoute.ButtonOrder;
import restore_first_time_passwordsHtml from './restore-first-time-passwords.html?raw';

export const template = restore_first_time_passwordsHtml

enum Step {
    Init,
    Confirm,
    Process,
    Success,
}

export class viewModel {
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private Step = Step;
    private readonly step = ko.observable<Step>(Step.Init);
    private readonly req_resettodefaultpassword = new PromiseRequest('resettodefaultpassword')
    private readonly pageButtons: ButtonManager = new ButtonManager()

    private permissionsAffected = [
        Permission.Employee,
        Permission.SuperEmployee,
        Permission.DepartmentAdmin,
        Permission.SuperManager,
    ].map(getPermissionDefinition)

    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()

    constructor(protected params: { dialog: IDialogOptionsComponent }) {
        this.messageData({message: PLEASE_WAIT_MESSAGE})
        this.kosub.subscribe(this.step, this.onStepChange.bind(this))

        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.(), {
            label: 'no, cancel',
            validator: () => this.isStep(Step.Init, Step.Confirm),
        }))
        this.pageButtons.add(getContinueButton({
            label: 'Yes, continue',
            onClick: () => this.onNextStepClick(),
            validator: () => this.isStep(Step.Init),
        }))
        this.pageButtons.add(getContinueButton({
            cssClass: 'danger',
            label: 'Yes, I am 100% sure',
            onClick: () => this.onNextStepClick(),
            validator: () => this.isStep(Step.Confirm),
        }))
        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.(), {
            cssClass: 'primary action',
            icon: 'fa-check',
            label: 'close',
            order: ButtonOrder.CONTINUE,
            validator: () => this.isStep(Step.Success),
        }))

        this.step(Step.Init)
    }

    private onStepChange(step: Step) {
        this.messageData(null)
        switch (step) {
            case Step.Init:
                break;
            case Step.Confirm:
                break;
            case Step.Process:
                this.messageData({message: RESTORING_MESSAGE})
                this.doProcess()
                break;
            case Step.Success:
                break;
        }
    }

    private doProcess() {
        return Promise.resolve()
            .then(() => this.req_resettodefaultpassword.request())
            .then(() => this.step(Step.Success))
            .catch((reason: string) => {
                this.step(Step.Init)
                this.messageData(createErrorMessage(String(reason)))
            })
    }

    private isStep(...steps: number[]): boolean {
        return isPartOf(this.step(), ...steps)
    }

    private onNextStepClick() {
        const step = this.step()
        this.step(step + 1 as Step)
    }
}
